/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Platform_Questions_Heading_TwoInputs */

const en_platform_questions_heading_two = /** @type {(inputs: Platform_Questions_Heading_TwoInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`your week across`)
};

const pl_platform_questions_heading_two = /** @type {(inputs: Platform_Questions_Heading_TwoInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`tu swój tydzień`)
};

/**
* | output |
* | --- |
* | "your week across" |
*
* @param {Platform_Questions_Heading_TwoInputs} inputs
* @param {{ locale?: "en" | "pl" }} options
* @returns {LocalizedString}
*/
export const platform_questions_heading_two = /** @type {((inputs?: Platform_Questions_Heading_TwoInputs, options?: { locale?: "en" | "pl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Platform_Questions_Heading_TwoInputs, { locale?: "en" | "pl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pl") return pl_platform_questions_heading_two(inputs)
	return en_platform_questions_heading_two(inputs)
});